import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  CLAIMLINES_FEATURE_KEY,
  initialState as claimLinesInitialState,
  claimLinesReducer
} from './+state/claim-lines.reducer';
import { ClaimLinesEffects } from './+state/claim-lines.effects';
import { ClaimLinesFacade } from './+state/claim-lines.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(CLAIMLINES_FEATURE_KEY, claimLinesReducer),
    EffectsModule.forFeature([ClaimLinesEffects])
  ],
  providers: [ClaimLinesFacade]
})
export class BackOfficeClaimsClaimLinesDataAccessClaimLinesModule {}
